export default __webpack_public_path__ + "static/media/weathericons-regular-webfont.520c26b1.ttf";